import { useEffect, useState } from "react";
import moment from 'moment'
import { focusElemnt, formatDate, navigation1, navigation3 } from "../../../../../utilityFunctions";
import ReportHeader from "../../../../common/ReportHeader";
import CustomDatePicker from "../../../../common/CustomDatePicker";
import { Grid, Box, Button } from '@mui/material'
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getTotalByKey, } from '../../../../generics/helper';
import { callAddFontRobotoBold } from '../../../../../assets/fonts/Roboto-bold';
import { callAddFontRobotoNormal } from '../../../../../assets/fonts/Roboto-normal';
import { excelConfig } from '../../../../../assets/extra/excelConfig';
import excelExport from '../../../../../assets/extra/export-excel';
import MultiSelectDropDown from "../../../../form-components/MultiSelectDropDownComponent";
import { cancelData, columnDefsPDF, columnDefs2, columnDefs3, statusData, userTypeDataWp } from "./constants";
import { useDispatch, useSelector } from "react-redux";
import { getCorporationList, getPaymentGatewayList } from "../../../../../redux/KSRTC_Redux/MasterConfig/MasterAction";
import { getONBGWBSSReportDataWapp, getTransStatusList } from "../../../../../redux/KSRTC_Redux/ReportsPage/ReportsAction";
import Alert from "../../../../common/Alert";
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth } from "../../AccountsReports/PreponePostpone/Constants";
import { onlineReportMenu, reportMenu } from "../../../../../redux/Actions";
import WhatsAppCancelledStatementTable from "./WhatsAppCancelledStatementTable";
import WhatsAppBookingStatementFailureTable from "./WhatsAppBookingStatementFailureTable";
import WhatsAppBookingStatementTable from "./WhatsAppBookingStatementTable";

const WhatsAppBookingStatement = () => {
    const dispatch = useDispatch()
    const store = useSelector((store) => store);
    const { user, masterConfig } = store
    const { corporationList, paymentGatewayList } = masterConfig
    const [selData, setSelData] = useState({
        bookedDate: formatDate(window.getTime ? window.getTime() : new Date()),
        userType: userTypeDataWp,
        paymentGatewayType: [],
        corporation: [],
        status: [statusData?.[0]],
        cancelType: cancelData,
        transStatus: []
    });
    const [showAlert, setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [filterCorporationList, setFilterCorporationList] = useState([])
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
    const handleResetValue = () => {
        let addCorporationCodeName = corporationList?.map((val) => ({ ...val, CorporationNameCode: `${val.CorporationName} (${val.CorporationCode})` }))
        setSelData({
            bookedDate: formatDate(window.getTime ? window.getTime() : new Date()),
            userType: userTypeDataWp,
            paymentGatewayType: [paymentGatewayList[0] || []],
            corporation: addCorporationCodeName || [],
            status: [statusData?.[0]],
            cancelType: cancelData,
            transStatus: transStatusList,
        })
    }
    const [showReport, setShowReport] = useState(false)
    const [reportTableData, setReportTableData] = useState({})
    const [reportType, setReportType] = useState(0)
    const [transStatusList, setTransStatusList] = useState([]);

    useEffect(() => {
        focusElemnt('summaryBookedDate')
    }, [])
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        try {
            const body = { RefundStatusID: 0, }
            const res = await dispatch(getTransStatusList(body));
            if (res.status === 200 && res.data.status) {
                if (res.data?.Data?.Table?.length > 0) {
                    setTransStatusList(res.data.Data.Table);
                    setSelData(prevData => ({
                        ...prevData,
                        transStatus: res.data.Data.Table
                    }));
                }
            } else {
                console.error('Error: Invalid response status or data');
            }
        } catch (error) {
            console.error('Error fetching report data:', error);
        }
    };
    useEffect(() => {
        // if (corporationList?.length > 0) {
        //     setSelData((prev) => ({ ...prev, corporation: corporationList }))
        // }
        if (corporationList?.length > 0) {
            let addCorporationCodeName = corporationList?.map((val) => ({ ...val, CorporationNameCode: `${val.CorporationName} (${val.CorporationCode})` }))
            setFilterCorporationList(addCorporationCodeName)
            setSelData((prev) => ({ ...prev, corporation: addCorporationCodeName }))
        }
    }, [corporationList])
    useEffect(() => {
        if (paymentGatewayList?.length > 0) {
            setSelData((prev) => ({ ...prev, paymentGatewayType: [paymentGatewayList[0]] }))
        }
    }, [paymentGatewayList])
    useEffect(() => {
        if (user?.CompanyID) {
            const CorporationBody = {
                CorporationID: 0,
                ClientID: user?.CompanyID === 1 ? 1 : 2
            }
            dispatch(getCorporationList(CorporationBody, true, 60 * 60 * 1000))
            const paymentGatewayBody = { PGID: 0, }
            dispatch(getPaymentGatewayList(paymentGatewayBody, true, 60 * 60 * 1000))
        }

    }, [user?.CompanyID])
    const userTypeProps = () => {
        return {
            id: 'userType',
            width: "100%",
            name: "SelectUserType",
            label: "",
            isCompulsory: false,
            options: userTypeDataWp || [],
            preSelectedValues: selData.userType,
            searchPlaceholder: "Search by User Type",
            disabled: false,
            isObject: true,
            primaryKey: 'id',
            labelKey: 'name',
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            prevId: "summaryBookedDate",
            nextId: "paymentGatewayType",
        }
    }
    const paymentGatewayTypeProps = () => {
        return {
            id: 'paymentGatewayType',
            width: "100%",
            name: "SelectPaymentGatewayType",
            // label: "RazorPay",
            isCompulsory: false,
            options: paymentGatewayList || [],
            preSelectedValues: selData?.paymentGatewayType,
            searchPlaceholder: "Search by Payment Gateway Type",
            disabled: false,
            isObject: true,
            primaryKey: 'PGID',
            labelKey: 'PGName',
            singleSelect: true,
            // selectAllOption: false,
            // defaultAllSelected: true,
            prevId: "userType",
            nextId: "corporation",
        }
    }
    const corporationProps = () => {
        return {
            id: 'corporation',
            width: "100%",
            name: "SelectCorporation",
            label: "",
            isCompulsory: false,
            options: filterCorporationList || [],
            preSelectedValues: selData.corporation,
            searchPlaceholder: "Search by Corporation",
            disabled: false,
            isObject: true,
            primaryKey: 'CorporationID',
            labelKey: 'CorporationNameCode',
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            prevId: "paymentGatewayType",
            nextId: "status",
            searchByCode: true,
            searchByName: "CorporationCode",
           // listWidth: 'max-content',
        }
    }
    const statusProps = () => {
        return {
            id: 'status',
            width: "100%",
            name: "Selectstatus",
            // label: "Success",
            isCompulsory: false,
            options: statusData || [],
            preSelectedValues: selData.status,
            searchPlaceholder: "Search by Status",
            disabled: false,
            isObject: true,
            primaryKey: 'id',
            labelKey: 'name',
            singleSelect: true,
            selectAllOption: false,
            defaultAllSelected: false,
            prevId: "corporation",
            nextId: "cancelType",
        }
    }
    const cancelTypeProps = () => {
        return {
            id: 'cancelType',
            width: "100%",
            name: "SelectcancelType",
            label: "",
            isCompulsory: false,
            options: cancelData || [],
            preSelectedValues: selData.cancelType,
            searchPlaceholder: "Search by Cancel Type",
            disabled: false,
            isObject: true,
            primaryKey: 'id',
            labelKey: 'name',
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            prevId: "status",
            nextId: "submitBTN",
        }
    }
    const transStatusProps = () => {
        return {
            id: 'transStatus',
            width: "100%",
            name: "transStatus",
            label: "",
            isCompulsory: false,
            options: transStatusList || [],
            preSelectedValues: selData?.transStatus,
            searchPlaceholder: "Search by Transaction Status",
            disabled: false,
            isObject: true,
            primaryKey: 'StatusID',
            labelKey: 'StatusName',
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            prevId: "withdrawaldate",
            nextId: "servicetype",
        }
    }
    const handleAlert = (msg) => {
        setShowAlert(true)
        setAlertMsg(msg)
    }
    // for Export as excel
    const reportExcelExport = async () => {
        if (selData?.corporation?.length <= 0) {
            handleAlert("Select Corporation")
        } else {
            try {
                const body = {
                    CompanyID: user?.CompanyID,
                    UserID: user?.UserID,
                    TxnDate: selData?.bookedDate,
                    UserTypeID: selData.userType?.length > 1 ? 0 : selData.userType?.[0]?.id,
                    PGType: selData?.paymentGatewayType?.[0]?.PGUsed,
                    CorporationID: selData?.corporation?.length > 1 ? 0 : selData?.corporation?.[0]?.CorporationID,
                    Status: selData?.status?.[0]?.id,
                    CancelType: selData?.cancelType?.length > 1 ? "All" : selData?.cancelType?.[0]?.id,
                    RefStatusID: selData?.transStatus?.length === 1 ? selData?.transStatus[0]?.StatusID : 0,
                }
                const res = await dispatch(getONBGWBSSReportDataWapp(body));
                if (res.status === 200 && res.data.status) {
                    let reportData = [];
                    if (res.data?.Data?.Table?.length > 0) {
                        reportData = res.data?.Data?.Table?.map((val, i) => ({ ...val, isDataRow: true, SN: i + 1, BkgDate: moment(val.BkgDate).format("DD-MMM-YYYY"), JDate: moment(val.JDate).format("DD-MMM-YYYY"), SeatCount: val.SeatNos?.split(",")?.length }))
                        const keys = ["Amount", "SeatCount"];
                        const totals = getTotalByKey(reportData, keys);
                        totals.OrderID = "GRAND TOTAL"
                        totals.SeatNos = totals.SeatCount
                        totals.isTotalRow = true
                        // totals.colSpan = 2
                        reportData.push(totals)
                    }
                    let xlColumns = []
                    if (selData?.status?.[0]?.id === "DB") {
                        xlColumns = columnDefs3.map((col) => {
                            return { colHeader: col.exportHead, field: col.field, xlCol: col.xlCol }
                        });
                        // xlColumns = columnDefsPDF.map((col) => {
                        //     return { colHeader: col.exportHead, field: col.field, xlCol: col.xlCol }
                        // });
                    } else if (selData?.status?.[0]?.id === "PDBF") {
                        xlColumns = columnDefs2.map((col) => {
                            return { colHeader: col.exportHead, field: col.field, xlCol: col.xlCol }
                        });
                    } else {
                        xlColumns = columnDefsPDF.map((col) => {
                            return { colHeader: col.exportHead, field: col.field, xlCol: col.xlCol }
                        });
                        // xlColumns = columnDefs3.map((col) => {
                        //     return { colHeader: col.exportHead, field: col.field, xlCol: col.xlCol }
                        // });
                    }
                    // const xlColumns = columnDefsPDF.map((col) => {
                    //     return { colHeader: col.exportHead, field: col.field, xlCol: col.xlCol }
                    // });

                    const xlConfig = {
                        ...excelConfig,
                        columns: xlColumns,
                        fileName: `WhatsApp_Bank_GateWay_Wise_Booking_Statement_Success.xlsx`,
                        showFilterSection: true,
                        showSummarySection: true,
                        showEmptyRow: true,
                        headerRowStyle: { fill: '', bold: true },
                        borderStyle: {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        },
                        showHeader: true,
                        workSheetTitle: `WhatsApp_Bank_GateWay_Wise_Booking_Statement_Success`,
                        headerFooter: {
                            firstHeader: "WhatsApp_Bank_GateWay_Wise_Booking_Statement_Success",
                            firstFooter: "WhatsApp_Bank_GateWay_Wise_Booking_Statement_Success"
                        },
                        sheetHeaderData: [
                            {
                                "caption": "KARNATAKA STATE ROAD TRANSPORT CORPORATION",
                                "colSpan": 17,
                                "horizontal": "center",
                                "newRow": true
                            },
                            {
                                "caption": selData?.status?.[0]?.id === "DB" ? "WhatsApp Bank/GateWay Wise Booking Statement/Success" : selData?.status?.[0]?.id === "PDBF" ? "WhatsApp Bank/GateWay Wise Booking Statement/Failure" : "WhatsApp Bank/GateWay Wise Booking Statement/Cancelled",
                                "colSpan": 17,
                                "size": 12,
                                "horizontal": "center",
                                "newRow": true
                            },
                            {
                                "caption": "Bus Station: All",
                                "colSpan": 17,
                                "size": 12,
                                "horizontal": "center",
                                "newRow": true
                            },
                            {
                                "caption": "Payment Gateway:",
                                "value": `${selData?.paymentGatewayType?.[0]?.PGName}`,
                                "colSpan": 8,
                                "size": 10,
                            },
                            {
                                "caption": "",
                                "value": ``,
                                "colSpan": 1,
                            },
                            {
                                "caption": `User : `,
                                "value": `${user?.UserName || ''} (${sessionStorage.getItem('LoginId') || ""})`,
                                "colSpan": 8,
                                "horizontal": "right",
                                "size": 10,
                                "newRow": true
                            }, {
                                "caption": " CORPORATION :",
                                "value": `${selData?.corporation?.length > 1 ? "All" : selData?.corporation?.[0]?.CorporationCode}`,
                                "colSpan": 8,
                                "size": 10
                            },
                            {
                                "caption": `Print Date & Time : `,
                                "value": `${currentDateTime}`,
                                "colSpan": 9,
                                "horizontal": "right",
                                "size": 10,
                                "newRow": true
                            }
                        ],
                    };
                    await excelExport.processExcel(xlConfig, reportData)
                } else {
                    handleAlert(res.data?.Message);
                }

            } catch (err) {
                console.log(err);
            }
        }
    }

    const printReport = async (isSave) => {
        // setState({ ...state, load: true, generatePDF: true })
        if (selData?.corporation?.length <= 0) {
            handleAlert("Select Corporation")
        } else {
            const body = {
                CompanyID: user?.CompanyID,
                UserID: user?.UserID,
                TxnDate: selData?.bookedDate,
                UserTypeID: selData.userType?.length > 1 ? 0 : selData.userType?.[0]?.id,
                PGType: selData?.paymentGatewayType?.[0]?.PGUsed,
                CorporationID: selData?.corporation?.length > 1 ? 0 : selData?.corporation?.[0]?.CorporationID,
                Status: selData?.status?.[0]?.id,
                CancelType: selData?.cancelType?.length > 1 ? "All" : selData?.cancelType?.[0]?.id,
                RefStatusID: selData?.transStatus?.length === 1 ? selData?.transStatus[0]?.StatusID : 0,
            }
            const res = await dispatch(getONBGWBSSReportDataWapp(body));
            if (res.status === 200 && res.data.status) {
                let reportData = [];
                if (res.data?.Data?.Table?.length > 0) {
                    reportData = res.data?.Data?.Table?.map((val, i) => ({ ...val, isDataRow: true, SN: i + 1, BkgDate: moment(val.BkgDate).format("DD-MMM-YYYY"), JDate: moment(val.JDate).format("DD-MMM-YYYY"), SeatCount: val.SeatNos?.split(",")?.length }))
                    const keys = ["Amount", "SeatCount"];
                    const totals = getTotalByKey(reportData, keys);
                    totals.OrderID = "GRAND TOTAL"
                    totals.SeatNos = totals.SeatCount
                    totals.isTotal = true
                    // totals.colSpan = 2
                    reportData.push(totals)
                }
                jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
                jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);
                let pdfColumns = []
                if (selData?.status?.[0]?.id === "DB") {
                    // pdfColumns = columnDefsPDF.map((col) => {
                    //     return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                    // })
                    pdfColumns = columnDefs3.map((col) => {
                        return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                    })
                } else if (selData?.status?.[0]?.id === "PDBF") {
                    pdfColumns = columnDefs2.map((col) => {
                        return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                    })
                } else {
                    pdfColumns = columnDefsPDF.map((col) => {
                        return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                    })
                    // pdfColumns = columnDefs3.map((col) => {
                    //     return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
                    // })
                }

                const widthCell = calculateTotalTableWidth(columnDefsPDF)
                // const doc = new jsPDF({ orientation: 'l', format: [1080, 1528], unit: 'px', compress: true })
                const doc = new jsPDF({ orientation: pdfColumns.length > 12 ? 'l' : 'p', format: pdfColumns.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 793 ? widthCell : 793) + 60), unit: 'px', compress: true })
                // var pageSize = doc.internal.pageSize
                // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                // var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
                // var scaleFactor = pageWidth / (pdfColumns.length > 12 ? 1122 : 793);
                // 793x1122
                doc.autoTableSetDefaults({
                    headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
                })
                var totalPagesExp = '{total_pages_count_string}'
                doc.setProperties({
                    title: `Online Report.pdf`,
                    subject: 'Report',
                    author: 'Karnataka State Road Transport Corporation',
                    keywords: 'Mantis Technologies Private Limited',
                    creator: 'KSRTC',
                })

                const startY = 180;
                autoTable(doc, {
                    margin: { top: 0, left: 20, right: 20, bottom: 3 },
                    startY: startY,
                    theme: 'grid',
                    head: [],
                    body: [[]],
                    didDrawPage: function (data) {
                        var doc = data.doc;
                        doc.setTextColor('#000000');

                        // Calculate text width and center for the first text
                        var text1 = 'KARNATAKA STATE ROAD TRANSPORT CORPORATION';
                        var textWidth1 = doc.getStringUnitWidth(text1) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                        var centerX1 = (doc.internal.pageSize.width - textWidth1) / 2;

                        // Set font size and style for the first text
                        doc.setFontSize(18).setFont("Roboto", 'normal', '700');
                        doc.setTextColor('#000000');
                        // Draw the first text at the calculated x-coordinate
                        doc.text(text1, centerX1, 60);

                        // Set font size, weight, and color for the second text
                        doc.setFontSize(14).setFont("Roboto", 'normal', '600');
                        doc.setTextColor('#000000');
                        // Calculate text width and center for the second text
                        var text2 = selData?.status?.[0]?.id === "DB" ? "WhatsApp Bank/GateWay Wise Booking Statement/Success" : selData?.status?.[0]?.id === "PDBF" ? "WhatsApp Bank/GateWay Wise Booking Statement/Failure" : "WhatsApp Bank/GateWay Wise Booking Statement/Cancelled";
                        var textWidth2 = doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                        var centerX2 = (doc.internal.pageSize.width - textWidth2) / 2;
                        // Draw the second text at the calculated x-coordinate below the first text
                        doc.text(text2, centerX2, 80); // Adjust the vertical position as needed
                        doc.setTextColor(0, 0, 0)
                        doc.setFontSize(18)
                        doc.setFont('Roboto', '')
                        doc.text(`CORPORATION:  ${selData?.corporation?.length > 1 ? "All" : selData?.corporation?.[0]?.CorporationCode}`, 30, 170)
                        doc.setFontSize(18)
                        doc.setFont('Roboto', '')
                        doc.text(`Payment Gateway : ${selData?.paymentGatewayType?.[0]?.PGName}`, 30, 145)
                        doc.setFontSize(18)
                        doc.setFont('Roboto', '')
                        doc.text(`User: ${user?.UserName || ''} (${sessionStorage.getItem('LoginId') || ""})`, doc.internal.pageSize.width - data.settings.margin.left, 125, 'right')
                        doc.text(`Print Date & Time: ${currentDateTime}`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
                    },
                })
                autoTable(doc, {
                    startY: doc.lastAutoTable.finalY,
                    margin: { top: 20, left: 20, right: 20, bottom: 20 },
                    alternateRowStyles: {
                        fillColor: [255, 255, 255],
                    },
                    columns: pdfColumns,
                    body: reportData,

                    columnStyles: selData?.status?.[0]?.id === "DB" ? {
                        0: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        1: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        2: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        3: { halign: 'right', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        4: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        5: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        6: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        7: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        8: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        9: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        10: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        11: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                        12: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },

                    } : selData?.status?.[0]?.id === "PDBF" ?
                        {

                            0: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            1: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            2: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            3: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            4: { halign: 'right', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            5: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            6: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            7: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            8: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            9: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            10: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            11: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            12: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            13: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            14: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            15: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },

                        } : {
                            0: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            1: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            2: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            3: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            4: { halign: 'right', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            5: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            6: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            7: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            8: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            9: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            10: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            11: { halign: 'left', fontSize: 14, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            12: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            13: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            14: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            15: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            16: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            17: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            18: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            19: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            20: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                            21: { halign: 'left', fontSize: 13, valign: 'middle', minCellWidth: 10, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },

                        },
                    // showHead: 'never',
                    theme: 'grid',
                    styles: {
                        lineWidth: [0, 0.2, 0, 0.6],
                    },
                    tableLineWidth: 0.6,
                    headStyles: {
                        fontSize: 16,
                        fillColor: [255, 255, 255],
                        textColor: [0, 0, 0],
                        cellPadding: 6,
                        valign: 'middle',
                        fontStyle: 'normal',
                        font: 'Roboto',

                    },
                    didParseCell: (data) => {
                        // drawCell(data)
                        if (data.row.section === 'head') {
                            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                                data.cell.styles.halign = 'right'
                            } else {
                                data.cell.styles.halign = 'left'
                            }
                        }
                    },

                })
                doc.setFont('Roboto')

                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                if (selData?.status?.[0]?.id === "DB") {
                    doc.save(`WhatsApp BankGateWayWiseBookingStatementSuccess Report ${new Date().getTime()}.pdf`)

                } else if (selData?.status?.[0]?.id === "PDBF") {
                    doc.save(`WhatsAppBankGateWayWiseBookingStatementFailure  Report ${new Date().getTime()}.pdf`)
                } else {
                    doc.save(`WhatsApp BANK / GATEWAY WISE CANCELLED STATEMENT  Report ${new Date().getTime()}.pdf`)
                }

            } else {
                handleAlert(res.data?.Message);
            }
        }

    }

    const handleSumbit = async () => {
        setShowReport(false)
        setReportTableData({})
        setReportType(0)
        if (selData?.corporation?.length <= 0) {
            handleAlert("Select Corporation")
        } else {
            const headerData = {
                paymentGatewayType: selData?.paymentGatewayType?.[0]?.PGName,
                corporation: selData?.corporation?.length > 1 ? "All" : selData?.corporation?.[0]?.CorporationCode,
                bookedDate: selData?.bookedDate
            };
            const body = {
                CompanyID: user?.CompanyID,
                UserID: user?.UserID,
                TxnDate: selData?.bookedDate,
                UserTypeID: selData.userType?.length > 1 ? 0 : selData.userType?.[0]?.id,
                PGType: selData?.paymentGatewayType?.[0]?.PGUsed,
                CorporationID: selData?.corporation?.length > 1 ? 0 : selData?.corporation?.[0]?.CorporationID,
                Status: selData?.status?.[0]?.id,
                CancelType: selData?.cancelType?.length > 1 ? "All" : selData?.cancelType?.[0]?.id,
                RefStatusID: selData?.transStatus?.length === 1 ? selData?.transStatus[0]?.StatusID : 0,
            }
            dispatch(getONBGWBSSReportDataWapp(body)).then((res) => {
                if (res?.status === 200 && res?.data?.status) {
                    setShowReport(true)
                    if (res?.data?.Data?.Table?.length > 0) {
                        setReportTableData({ header: headerData, TableData: res?.data?.Data?.Table })
                        if (selData?.status?.[0]?.id === "DB") {
                            setReportType(1)
                        } else if (selData?.status?.[0]?.id === "PDBF") {
                            setReportType(2)
                        } else {
                            setReportType(3)
                        }
                    } else {
                        handleAlert("No Data Found")
                        return
                        // setReportTableData({ header: headerData, TableData: [] })
                        // if (selData?.status?.[0]?.id === "DB") {
                        //     setReportType(1)
                        // } else if (selData?.status?.[0]?.id === "PDBF") {
                        //     setReportType(2)
                        // } else {
                        //     setReportType(0)
                        // }
                    }
                } else {
                    handleAlert(res.data?.Message);
                }
            })
        }
    }

    return (
        <>
            {reportType === 0 ?
                <Box>
                    <ReportHeader mainHeaderName='Report' headerName='Online Report' openSubMenu={() => dispatch(reportMenu(true))} subHeader={'WhatsApp Bank/GateWay Wise Booking Statement/Success'} subHeaderVisible={() => dispatch(onlineReportMenu(true))} mainMenuOpen={true} />
                    <Grid
                        container
                        spacing={0}
                        className="column-container"
                        style={{
                            padding: "16px 16px 58px 16px",
                        }}
                    >
                        <Grid item md={6.5}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px'
                            }}
                        >
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: '700'
                                }}
                            >
                                <Grid item md={4}>Booked Date</Grid>
                                <Grid item md={8}>
                                    <CustomDatePicker label={''} id="summaryBookedDate" selectedDate={selData?.bookedDate}
                                        onChange={(value) => {
                                            setSelData((prev) => ({
                                                ...prev,
                                                bookedDate: formatDate(value)
                                            }))
                                        }}
                                        minDate={'2024-06-19'}
                                        onKeyDown={(e) => { navigation1(e, 'userType', '') }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <Grid item md={4} style={{ fontWeight: '700' }}>User Type</Grid>
                                <Grid item md={8}>
                                    <MultiSelectDropDown
                                        {...userTypeProps()}
                                        onSelect={(val) => {
                                            setSelData((prev) => ({
                                                ...prev,
                                                userType: val
                                            }))
                                        }
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <Grid item md={4} style={{ fontWeight: '700' }}>Payment Gateway Type</Grid>
                                <Grid item md={8}>
                                    <MultiSelectDropDown
                                        {...paymentGatewayTypeProps()}
                                        onSelect={(val) => {
                                            setSelData((prev) => ({
                                                ...prev,
                                                paymentGatewayType: val
                                            }))
                                        }
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <Grid item md={4} style={{ fontWeight: '700' }}>Corporation</Grid>
                                <Grid item md={8}>
                                    <MultiSelectDropDown
                                        {...corporationProps()}
                                        onSelect={(val) => {
                                            setSelData((prev) => ({
                                                ...prev,
                                                corporation: val
                                            }))
                                        }
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <Grid item md={4} style={{ fontWeight: '700' }}>Status</Grid>
                                <Grid item md={8}>
                                    <MultiSelectDropDown
                                        {...statusProps()}
                                        onSelect={(val) => {
                                            setSelData((prev) => ({
                                                ...prev,
                                                status: val,
                                                cancelType: cancelData
                                            }))
                                        }
                                        }
                                    />
                                </Grid>
                            </Grid>
                            {selData?.status?.[0]?.id === 'DC' &&
                                <>
                                    <Grid
                                        container
                                        direction='row'
                                        style={{
                                            paddingRight: '30px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Grid item md={4} style={{ fontWeight: '700' }}>Cancel Type</Grid>
                                        <Grid item md={8}>
                                            <MultiSelectDropDown
                                                {...cancelTypeProps()}
                                                onSelect={(val) => {
                                                    setSelData((prev) => ({
                                                        ...prev,
                                                        cancelType: val
                                                    }))
                                                }
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        direction='row'
                                        style={{
                                            paddingRight: '30px'
                                        }}
                                    >
                                        <Grid item md={4} style={{ fontWeight: '700' }}>Transaction Status</Grid>
                                        <Grid item md={8}>
                                            <MultiSelectDropDown id="travelType"
                                                {...transStatusProps()}
                                                onSelect={(val) => {
                                                    setSelData((prev) => ({
                                                        ...prev,
                                                        transStatus: val
                                                    }))
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            }
                            <Grid
                                container
                                direction='row'
                                style={{
                                    paddingRight: '30px',
                                    gap: '10px',
                                    flexWrap: 'nowrap'
                                }}
                            >
                                <Grid item md={4}></Grid>
                                <Grid item md={2}>
                                    <Button variant="contained" size="medium" id="submitBTN"
                                        className={`btn-orange`}
                                        onClick={() => handleSumbit()}
                                        onKeyDown={(e) => navigation3(e, "pdfBTN", "cancelType", () => handleSumbit())}
                                    >
                                        SUBMIT
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        id="pdfBTN"
                                        className="btn-orange-outline"
                                        onClick={() => printReport()}
                                        onKeyDown={(e) => navigation3(e, "excelBTN", "submitBTN", () => { printReport() })}
                                    >
                                        PDF
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        className="btn-orange-outline"
                                        id="excelBTN"
                                        onClick={() => reportExcelExport()}
                                        onKeyDown={(e) => navigation3(e, "resetBTN", "pdfBTN", () => { reportExcelExport() })}
                                    >
                                        EXCEL
                                    </Button>
                                </Grid>
                                <Grid item md={2}>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        id="resetBTN"
                                        className="btn-orange-outline"
                                        onClick={() => handleResetValue()}
                                        onKeyDown={(e) => navigation3(e, "", "excelBTN", () => { handleResetValue() })}
                                    >
                                        RESET
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* {isPdfLoaded &&
                    <>
                        <object id="output" type="application/pdf" width="100%" height="350" title="MTLPL - BusCRS - Agent Voucher Report" aria-label="MTLPL - BusCRS - Agent Voucher Report"></object>
                    </>
                } */}
                </Box >
                :
                reportType === 1 ?
                    <WhatsAppCancelledStatementTable reportTableData={reportTableData} handleBack={() => {
                        setReportTableData({});
                        setShowReport(false)
                        setReportType(0)
                    }} />
                    : reportType === 2 ?
                        <WhatsAppBookingStatementFailureTable reportTableData={reportTableData} handleBack={() => {
                            setReportTableData({});
                            setShowReport(false)
                            setReportType(0)
                        }} />
                        : reportType === 3 ?
                            <WhatsAppBookingStatementTable reportTableData={reportTableData} handleBack={() => {
                                setReportTableData({});
                                setShowReport(false)
                                setReportType(0)
                            }} /> : null
            }
            {showAlert && (
                <Alert
                    msg={alertMsg} alertType={"error"} close={() => setShowAlert(false)} buttonText="Ok"
                />
            )}
        </>
    )
}

export default WhatsAppBookingStatement;